import React from "react";
import { useTranslation } from "react-i18next";
import { formatText } from "../../../utils/formatUtils";

interface FieldProps {
    label: string;
    value: string | number | boolean | null | undefined;
    className?: string;
}

const Field: React.FC<FieldProps> = ({ label, value, className = "" }) => {
    const { t } = useTranslation('publicProfile');
    return (
        <div className={`space-y-1 ${className}`}>
            <label className="text-sm font-normal text-gray-600 tracking-wide">
                {t(label.toLowerCase().replace(/\s/g, '_'))}
            </label>
            <p className="text-sm text-gray-900 font-medium">{formatText(value)}</p>
        </div>
    );
};

export default Field;